/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { WebhookDeliveryDto } from '../models/webhook-delivery-dto';
import { WebhookEventDto } from '../models/webhook-event-dto';
import { webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json } from '../fn/webhook-monitoring/webhooks-monitoring-endpoints-webhook-endpoint-id-deliveries-get-json';
import { WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json$Params } from '../fn/webhook-monitoring/webhooks-monitoring-endpoints-webhook-endpoint-id-deliveries-get-json';
import { webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain } from '../fn/webhook-monitoring/webhooks-monitoring-endpoints-webhook-endpoint-id-deliveries-get-plain';
import { WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain$Params } from '../fn/webhook-monitoring/webhooks-monitoring-endpoints-webhook-endpoint-id-deliveries-get-plain';
import { webhooksMonitoringEventsPost$Json } from '../fn/webhook-monitoring/webhooks-monitoring-events-post-json';
import { WebhooksMonitoringEventsPost$Json$Params } from '../fn/webhook-monitoring/webhooks-monitoring-events-post-json';
import { webhooksMonitoringEventsPost$Plain } from '../fn/webhook-monitoring/webhooks-monitoring-events-post-plain';
import { WebhooksMonitoringEventsPost$Plain$Params } from '../fn/webhook-monitoring/webhooks-monitoring-events-post-plain';
import { webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json } from '../fn/webhook-monitoring/webhooks-monitoring-events-webhook-event-id-deliveries-get-json';
import { WebhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json$Params } from '../fn/webhook-monitoring/webhooks-monitoring-events-webhook-event-id-deliveries-get-json';
import { webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain } from '../fn/webhook-monitoring/webhooks-monitoring-events-webhook-event-id-deliveries-get-plain';
import { WebhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain$Params } from '../fn/webhook-monitoring/webhooks-monitoring-events-webhook-event-id-deliveries-get-plain';

@Injectable({ providedIn: 'root' })
export class WebhookMonitoringApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `webhooksMonitoringEventsPost()` */
  static readonly WebhooksMonitoringEventsPostPath = '/webhooks/monitoring/events';

  /**
   * List webhook events.
   *
   * Lists webhook events for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhooksMonitoringEventsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  webhooksMonitoringEventsPost$Plain$Response(params?: WebhooksMonitoringEventsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEventDto>>> {
    const obs = webhooksMonitoringEventsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List webhook events.
   *
   * Lists webhook events for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhooksMonitoringEventsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  webhooksMonitoringEventsPost$Plain(params?: WebhooksMonitoringEventsPost$Plain$Params, context?: HttpContext): Observable<Array<WebhookEventDto>> {
    const resp = this.webhooksMonitoringEventsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookEventDto>>): Array<WebhookEventDto> => r.body)
    );
  }

  /**
   * List webhook events.
   *
   * Lists webhook events for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhooksMonitoringEventsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  webhooksMonitoringEventsPost$Json$Response(params?: WebhooksMonitoringEventsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEventDto>>> {
    const obs = webhooksMonitoringEventsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List webhook events.
   *
   * Lists webhook events for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhooksMonitoringEventsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  webhooksMonitoringEventsPost$Json(params?: WebhooksMonitoringEventsPost$Json$Params, context?: HttpContext): Observable<Array<WebhookEventDto>> {
    const resp = this.webhooksMonitoringEventsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookEventDto>>): Array<WebhookEventDto> => r.body)
    );
  }

  /** Path part for operation `webhooksMonitoringEventsWebhookEventIdDeliveriesGet()` */
  static readonly WebhooksMonitoringEventsWebhookEventIdDeliveriesGetPath = '/webhooks/monitoring/events/{webhookEventId}/deliveries';

  /**
   * Get deliveries for event.
   *
   * Returns webhook deliveries for a given event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain$Response(params: WebhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookDeliveryDto>>> {
    const obs = webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get deliveries for event.
   *
   * Returns webhook deliveries for a given event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain(params: WebhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain$Params, context?: HttpContext): Observable<Array<WebhookDeliveryDto>> {
    const resp = this.webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookDeliveryDto>>): Array<WebhookDeliveryDto> => r.body)
    );
  }

  /**
   * Get deliveries for event.
   *
   * Returns webhook deliveries for a given event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json$Response(params: WebhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookDeliveryDto>>> {
    const obs = webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get deliveries for event.
   *
   * Returns webhook deliveries for a given event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json(params: WebhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json$Params, context?: HttpContext): Observable<Array<WebhookDeliveryDto>> {
    const resp = this.webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookDeliveryDto>>): Array<WebhookDeliveryDto> => r.body)
    );
  }

  /** Path part for operation `webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet()` */
  static readonly WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGetPath = '/webhooks/monitoring/endpoints/{webhookEndpointId}/deliveries';

  /**
   * Get deliveries for endpoint.
   *
   * Returns webhook deliveries for a specific endpoint.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain$Response(params: WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookDeliveryDto>>> {
    const obs = webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get deliveries for endpoint.
   *
   * Returns webhook deliveries for a specific endpoint.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain(params: WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain$Params, context?: HttpContext): Observable<Array<WebhookDeliveryDto>> {
    const resp = this.webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookDeliveryDto>>): Array<WebhookDeliveryDto> => r.body)
    );
  }

  /**
   * Get deliveries for endpoint.
   *
   * Returns webhook deliveries for a specific endpoint.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json$Response(params: WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookDeliveryDto>>> {
    const obs = webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get deliveries for endpoint.
   *
   * Returns webhook deliveries for a specific endpoint.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json(params: WebhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json$Params, context?: HttpContext): Observable<Array<WebhookDeliveryDto>> {
    const resp = this.webhooksMonitoringEndpointsWebhookEndpointIdDeliveriesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WebhookDeliveryDto>>): Array<WebhookDeliveryDto> => r.body)
    );
  }

}
